export default {
  myWork_no_homework: '还没有作业',
  myWork_homework_list: '0407Web-显示我的作业列表',
}
